export default __webpack_public_path__ + "static/media/ZM.37f40dce.svg";